import { Tool } from '../../types';

export const timeTrackingTools: Tool[] = [
  {
    id: 'toggl',
    name: 'Toggl Track',
    category: 'Time Tracking',
    description: 'Simple and powerful time tracking for teams and freelancers',
    pricing: ['free', 'low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['agency', 'consulting-firm', 'service-business'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['creative', 'technology', 'consulting'],
    website: 'https://toggl.com/?via=anton-san-martin',
    imageUrl: 'https://logo.clearbit.com/toggl.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  },
  {
    id: 'rescuetime',
    name: 'RescueTime',
    category: 'Time Tracking & Productivity',
    description: 'Automatic time tracking and productivity analytics',
    pricing: ['free', 'low'],
    features: ['automation', 'mobile', 'ease-of-use'],
    bestFor: ['freelancer', 'startup'],
    compatibleWith: ['content-creator', 'service-business'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['technology', 'creative', 'consulting'],
    website: 'https://www.rescuetime.com',
    imageUrl: 'https://logo.clearbit.com/rescuetime.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'harvest',
    name: 'Harvest',
    category: 'Time Tracking',
    description: 'Time tracking and invoicing software for teams',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['agency', 'consulting-firm'],
    goals: ['streamline-operations', 'reduce-costs'],
    industries: ['creative', 'consulting', 'technology'],
    website: 'https://www.getharvest.com',
    imageUrl: 'https://logo.clearbit.com/getharvest.com',
    idealStages: ['growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];